export const it = {
    languages: {
        cs: 'Ceco',
        de: 'Tedesco',
        en: 'Inglese',
        es: 'Spagnolo',
        fr: 'Francese',
        hr: 'Croato',
        hu: 'Ungherese',
        it: 'Italiano',
        nl: 'Olandese',
        pl: 'Polacco',
        ru: 'Russo',
        sk: 'Slovacco',
        tr: 'Turco',
        uk: 'Ucraino',
        undefined: 'Nessun sottotitolo',
    },
    player: {
        content: {
            notFound: { title: "Errore durante il caricamento dell'elemento multimediale 😞" },
        },
        controls: {
            backwards: { title: '10s indietro' },
            buffering: { title: 'Caricamento...' },
            captions: { title: 'Sottotitoli' },
            forwards: { title: '10s avanti' },
            fullscreen: { title: 'Schermo intero' },
            pause: { title: 'Pausa' },
            play: { title: 'Riproduci' },
            playlist: { title: 'Playlist' },
            volume: { title: 'Volume' },
        },
    },
};
